import React from 'react';

function Lessons() {
  return (
    <div>
      <h1>Language Lessons</h1>
      {/* Add your vocabulary component content here */}
    </div>
  );
}

export default Lessons;